import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import styled from '@emotion/styled';

const Label = styled.span`
    font-size: 14px;
    font-weight: 700;
`;

export const SHAPE_FIELD_TYPE_OPTIONS = [
    { value: 'shipper', label: 'Shipper' },
    { value: 'manufacturer', label: 'Manufacturer' },
    { value: 'item_type', label: 'Item Type' },
    { value: 'template_name', label: 'Template Name' },
    { value: 'custom_shape', label: 'Custom Shape' },
    { value: 'order_tags', label: 'Route Tags' },
    { value: 'order_type', label: 'Order Type' },
];

export const renderShapeFieldTypeMenuItems = (shapeFieldTypeOptions) =>
    SHAPE_FIELD_TYPE_OPTIONS.map(({ value, label }) => (
        <MenuItem key={value} disabled={!shapeFieldTypeOptions.includes(value)} value={value}>
            <Label>{label}</Label>
        </MenuItem>
    ));
